import React from "react";
import { CheckboxGroupState } from "react-stately";

export const CheckboxContext = React.createContext<CheckboxGroupState>({
  isDisabled: false,
  isReadOnly: false,
  isSelected: () => false,
  value: [],
  setValue: () => {},
  addValue: () => {},
  removeValue: () => {},
  toggleValue: () => {},
  validationState: "valid",
});
